
{
  "familyId": "TOPO-NL-BUURLANDEN",
  "questions": [
    {
      "id": "TOPO-NL-BUURLANDEN-001",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Een vrachtwagenchauffeur wil van Nederland naar een buurland rijden. Welke landen kan hij bereiken zonder een ander land te doorkruisen?",
      "context": null,
      "options": ["België en Duitsland", "België en Frankrijk", "Duitsland en Denemarken", "België, Duitsland en Luxemburg"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Buurlanden van Nederland", "content": "Nederland heeft twee buurlanden op het land: België in het zuiden en Duitsland in het oosten. In het noorden en westen ligt de Noordzee.", "icon": "lightbulb"}}],
      "conceptId": "nl_buurlanden_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "De chauffeur kan direct naar België (zuiden) of Duitsland (oosten) rijden — dat zijn de twee buurlanden van Nederland. Voor Frankrijk of Denemarken moet hij eerst door een ander land. Luxemburg grenst niet aan Nederland (België zit ertussen).",
        "solutionSteps": ["Een buurland is een land dat direct aan jouw land grenst", "In het zuiden: België ✓", "In het oosten: Duitsland ✓", "In het noorden en westen: de Noordzee (geen buurlanden)", "Antwoord: België en Duitsland"],
        "distractorExplanations": {"0": "Goed! Nederland grenst aan België (zuiden) en Duitsland (oosten).", "1": "Je dacht waarschijnlijk dat Frankrijk aan Nederland grenst. Maar Frankrijk grenst aan België, niet aan Nederland. De chauffeur moet eerst door België rijden om Frankrijk te bereiken.", "2": "Je dacht waarschijnlijk dat Denemarken aan Nederland grenst. Maar Denemarken ligt ten noorden van Duitsland. De chauffeur moet eerst door Duitsland rijden om Denemarken te bereiken.", "3": "Je dacht waarschijnlijk dat Luxemburg aan Nederland grenst. Maar kijk goed op de kaart: er zit een stuk België tussen Nederland en Luxemburg."}
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-002",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Een piloot vliegt vanuit Amsterdam naar het zuiden. Over welk buurland vliegt hij het eerst?",
      "context": null,
      "options": ["België", "Duitsland", "Frankrijk", "Luxemburg"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Windrichtingen en buurlanden", "content": "Op een kaart is boven = noorden, onder = zuiden, rechts = oosten, links = westen. België ligt onder Nederland op de kaart, dus in het zuiden. Duitsland ligt rechts, in het oosten.", "icon": "lightbulb"}}],
      "conceptId": "nl_belgie_richting",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De piloot vliegt naar het zuiden en komt dan als eerste over België. België ligt direct ten zuiden van Nederland. Duitsland ligt in het oosten. Frankrijk en Luxemburg liggen verder weg — je moet eerst over België vliegen.",
        "solutionSteps": ["Amsterdam ligt in het westen van Nederland", "De piloot vliegt naar het zuiden", "België ligt direct ten zuiden van Nederland", "Antwoord: de piloot vliegt als eerste over België"],
        "distractorExplanations": {"0": "Goed! België ligt in het zuiden van Nederland.", "1": "Je dacht waarschijnlijk dat Duitsland in het zuiden ligt. Maar Duitsland ligt in het oosten van Nederland. België ligt in het zuiden. Onthoud: België = zuiden, Duitsland = oosten.", "2": "Je dacht waarschijnlijk dat Frankrijk direct ten zuiden van Nederland ligt. Maar België ligt tussen Nederland en Frankrijk. De piloot vliegt eerst over België.", "3": "Je dacht waarschijnlijk dat Luxemburg ten zuiden van Nederland ligt. Maar België ligt tussen Nederland en Luxemburg. De piloot vliegt eerst over België."}
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-003",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Een leerling moet een werkstuk maken over het buurland in het oosten. Hij zoekt informatie over de hoofdstad van dat land. Welke stad is dat?",
      "context": null,
      "options": ["Berlijn", "München", "Hamburg", "Frankfurt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdstad van Duitsland", "content": "Het buurland in het oosten is Duitsland. De hoofdstad van Duitsland is Berlijn. München, Hamburg en Frankfurt zijn grote steden, maar niet de hoofdstad.", "icon": "lightbulb"}}],
      "conceptId": "nl_buurland_duitsland_hoofdstad",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Het buurland in het oosten is Duitsland, en de hoofdstad daarvan is Berlijn. De leerling zoekt dus informatie over Berlijn. München, Hamburg en Frankfurt zijn grote steden in Duitsland, maar niet de hoofdstad.",
        "solutionSteps": ["Welk buurland ligt in het oosten? Duitsland", "Wat is de hoofdstad van Duitsland? Berlijn", "München = Beieren, Hamburg = havenstad, Frankfurt = financiën"],
        "distractorExplanations": {"0": "Goed! Berlijn is de hoofdstad van Duitsland.", "1": "Je dacht waarschijnlijk dat München de hoofdstad is. München is de hoofdstad van de deelstaat Beieren (bekend van het Oktoberfest), maar de hoofdstad van heel Duitsland is Berlijn.", "2": "Je dacht waarschijnlijk dat Hamburg de hoofdstad is. Hamburg is een grote havenstad in het noorden van Duitsland, maar de hoofdstad is Berlijn.", "3": "Je dacht waarschijnlijk dat Frankfurt de hoofdstad is. Frankfurt is het financiële centrum van Duitsland (daar zit de Europese Centrale Bank), maar de hoofdstad is Berlijn."}
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-004",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Een journalist reist naar de hoofdstad van het zuidelijke buurland van Nederland voor een EU-vergadering. Naar welke stad reist hij?",
      "context": null,
      "options": ["Brussel", "Antwerpen", "Gent", "Luik"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdstad van België", "content": "Het zuidelijke buurland is België. De hoofdstad van België is Brussel. Brussel is ook de hoofdstad van de Europese Unie — daar vinden veel EU-vergaderingen plaats.", "icon": "lightbulb"}}],
      "conceptId": "nl_buurland_belgie_hoofdstad",
      "variantIndex": 4,
      "citoDifficulty": 0.23,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het zuidelijke buurland is België, en de hoofdstad daarvan is Brussel. Brussel is ook de hoofdstad van de Europese Unie — daarom vinden daar veel EU-vergaderingen plaats. Antwerpen, Gent en Luik zijn grote steden, maar niet de hoofdstad.",
        "solutionSteps": ["Welk buurland ligt in het zuiden? België", "Wat is de hoofdstad van België? Brussel", "Brussel is ook de hoofdstad van de EU", "Antwerpen, Gent en Luik zijn grote steden, maar niet de hoofdstad"],
        "distractorExplanations": {"0": "Goed! Brussel is de hoofdstad van België én van de EU.", "1": "Je dacht waarschijnlijk dat Antwerpen de hoofdstad is. Antwerpen is de grootste stad van Vlaanderen en heeft een grote haven, maar de hoofdstad is Brussel.", "2": "Je dacht waarschijnlijk dat Gent de hoofdstad is. Gent is een grote universiteitsstad in België, maar de hoofdstad is Brussel.", "3": "Je dacht waarschijnlijk dat Luik de hoofdstad is. Luik (Liège) is een stad in het Franstalige deel van België (Wallonië), maar de hoofdstad is Brussel."}
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-005",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Een quizmaster stelt de vraag: 'Welke stelling over de buurlanden van Nederland is juist?' Wat is het goede antwoord?",
      "context": null,
      "options": ["Nederland heeft twee buurlanden: België en Duitsland.", "Nederland heeft drie buurlanden: België, Duitsland en Luxemburg.", "Nederland heeft één buurland: Duitsland.", "Nederland heeft geen buurlanden, alleen de Noordzee."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Buurlanden tellen", "content": "Een buurland is een land dat direct aan jouw land grenst. Nederland grenst aan België (zuiden) en Duitsland (oosten). Dat zijn twee buurlanden. Luxemburg grenst NIET aan Nederland.", "icon": "lightbulb"}}],
      "conceptId": "nl_buurlanden_overzicht",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Nederland heeft precies twee buurlanden op het land: België (zuiden) en Duitsland (oosten). In het noorden en westen grenst Nederland aan de Noordzee. Luxemburg grenst niet aan Nederland — er zit een stuk België tussen.",
        "solutionSteps": ["Tel de landen die direct aan Nederland grenzen", "België grenst aan Nederland in het zuiden ✓", "Duitsland grenst aan Nederland in het oosten ✓", "Luxemburg grenst NIET aan Nederland (België zit ertussen)", "Antwoord: twee buurlanden"],
        "distractorExplanations": {"0": "Goed! Nederland heeft twee buurlanden: België en Duitsland.", "1": "Je dacht waarschijnlijk dat Luxemburg ook aan Nederland grenst. Maar kijk goed op de kaart: tussen Nederland en Luxemburg ligt een stuk België.", "2": "Je dacht waarschijnlijk dat België niet aan Nederland grenst. Maar België ligt direct ten zuiden van Nederland. Nederland heeft twee buurlanden: België én Duitsland.", "3": "Je dacht waarschijnlijk dat Nederland alleen aan zee grenst. Maar Nederland grenst ook aan twee landen: België (zuiden) en Duitsland (oosten)."}
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-006",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "matching",
      "question": "Koppel elk buurland aan de juiste informatie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "België", "right": "Ligt ten zuiden van Nederland"},
          {"left": "Duitsland", "right": "Ligt ten oosten van Nederland"},
          {"left": "Brussel", "right": "Hoofdstad van België"},
          {"left": "Berlijn", "right": "Hoofdstad van Duitsland"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Buurlanden overzicht", "content": "Nederland heeft twee buurlanden: België (zuiden, hoofdstad Brussel) en Duitsland (oosten, hoofdstad Berlijn). Brussel is ook de hoofdstad van de EU.", "icon": "lightbulb"}}],
      "conceptId": "buurlanden_matching",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "België ligt ten zuiden van Nederland (hoofdstad: Brussel). Duitsland ligt ten oosten van Nederland (hoofdstad: Berlijn). Brussel is ook de hoofdstad van de Europese Unie.",
        "solutionSteps": ["België → ligt ten zuiden van Nederland", "Duitsland → ligt ten oosten van Nederland", "Brussel → hoofdstad van België (en van de EU)", "Berlijn → hoofdstad van Duitsland"]
      }
    }
  ]
}
